// ============================================================================
// ACCESS ERROR SCREEN
// Phase 2A: Blocking error screen when access cannot be resolved
// ============================================================================

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

/**
 * Blocking error screen shown when access cannot be resolved
 * Prevents silent fallback to dashboards
 */
export const AccessErrorScreen = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            <CardTitle>Access Error</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">
            We couldn't determine your access level. This may be a temporary issue.
          </p>
          <p className="text-sm text-muted-foreground">
            Please try logging out and back in, or contact support if the problem persists.
          </p>
          <div className="flex gap-2">
            <Button
              variant="outline"
              onClick={() => navigate("/login")}
              className="flex-1"
            >
              Go to Login
            </Button>
            <Button
              onClick={() => window.location.reload()}
              className="flex-1"
            >
              Refresh Page
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

